var map = {
	"./Biofouling/Biofouling.png": 5119,
	"./Biofouling/drag-drop.png": 7295,
	"./BiomassApp/BiomassApp.png": 8937,
	"./Cagedetection/Cagedetection.png": 7065,
	"./Custom/Custom.png": 2521,
	"./FishCounting/FishCounting.png": 5481,
	"./Inspection/Inspection.png": 4487,
	"./Mortality/Mortality.png": 2833,
	"./SalmorApp/SalmorApp.png": 4781,
	"./Satellites/Guide_Images/chlorophyll.png": 4613,
	"./Satellites/Guide_Images/current.png": 8054,
	"./Satellites/Guide_Images/oxygen.png": 1869,
	"./Satellites/Guide_Images/salinity.png": 3098,
	"./Satellites/Guide_Images/temperature.png": 2087,
	"./Satellites/Satellites.png": 5603,
	"./Satellites/cover.png": 1016,
	"./TableApp/TableApp.png": 4233,
	"./Waste/Waste.png": 7269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5592;